/*
  Stands in for the product form's Add to cart button once that button has
  scrolled off a phone screen. The two product templates put the real button in
  different places — a buy_buttons block on one, the quick-add panel on the other
  — and which one is on screen is only settled after the page has laid out, so
  the button to follow is looked up as we go rather than once at startup. The bar
  holds no state: it forwards its clicks and copies how the real button looks.
*/
(() => {
  const bar = document.querySelector('[data-product-sticky-atc]');
  const proxy = bar && bar.querySelector('button');

  if (!proxy) {
    return;
  }

  const textOf = (button) => button.querySelector('.button__text') || button;

  let real = null;
  let watcher = null;

  const sync = () => {
    if (!real) {
      return;
    }

    proxy.disabled = real.hasAttribute('disabled');
    proxy.classList.toggle('is-loading', real.classList.contains('is-loading'));
    textOf(proxy).textContent = textOf(real).textContent;
  };

  const follow = (button) => {
    real = button;

    if (watcher) {
      watcher.disconnect();
    }

    watcher = new MutationObserver(sync);
    watcher.observe(real, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    sync();
  };

  const update = () => {
    const onPage = [...document.querySelectorAll('.main-product__form-submit')].find(
      (button) => button.offsetParent !== null
    );

    if (!onPage) {
      bar.hidden = true;
      return;
    }

    if (onPage !== real) {
      follow(onPage);
    }

    // Hidden while the real button is anywhere on screen, including before the
    // shopper has scrolled down to it.
    bar.hidden = real.getBoundingClientRect().bottom > 0;
  };

  let ticking = false;

  const onScroll = () => {
    if (ticking) {
      return;
    }

    ticking = true;

    requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  };

  proxy.addEventListener('click', () => real && real.click());

  update();

  window.addEventListener('load', update);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
